/**
 * 智能助手话术（WS type=2000）解析
 * 新结构: message = JSON字符串
 *   [{ name: "千问", response: "句1\\n句2\\n句3" }, ...]
 * 兼容旧结构: response 为 [{ utter1: "..." }, ...]
 */

export function parseAiAssistantMessage(message) {
  if (typeof message === "string") {
    const trimmed = message.trim();
    if (!trimmed) return [];
    return JSON.parse(trimmed);
  }
  if (Array.isArray(message)) return message;
  return [];
}

/** 从单条模型的 response 抽出可用话术文本列表 */
export function extractAiResponseTexts(response) {
  if (response == null || response === "") return [];

  if (typeof response === "string") {
    const lines = response
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (lines.length > 0) return lines;
    const whole = response.trim();
    return whole ? [whole] : [];
  }

  if (Array.isArray(response)) {
    const list = [];
    response.forEach((item) => {
      if (typeof item === "string") {
        const t = item.trim();
        if (t) list.push(t);
        return;
      }
      if (item && typeof item === "object") {
        const keys = Object.keys(item);
        if (keys.length > 0) {
          const t = String(item[keys[0]] || "").trim();
          if (t) list.push(t);
        }
      }
    });
    return list;
  }

  return [];
}

export function buildAiAssistantItems(payload) {
  const data = payload || {};
  const messageArray = parseAiAssistantMessage(data.message);
  const items = [];
  const stamp = Date.now();

  messageArray.forEach((model, modelIndex) => {
    const modelName = (model && model.name) || "模型" + (modelIndex + 1);
    const texts = extractAiResponseTexts(model && model.response);
    texts.forEach((content, respIndex) => {
      items.push({
        id: "ai_" + modelIndex + "_" + respIndex + "_" + stamp,
        modelName,
        content: String(content),
      });
    });
  });

  return {
    cid: data.cid || "",
    sid: data.sid || "",
    items,
  };
}
